import { useAtom } from 'jotai'
import { useEffect, useRef } from 'react'
import nipplejs, { JoystickManagerOptions, Joystick, JoystickManager } from 'nipplejs'
import { activeMobileDirectionsAtom, activeMobileSprintAtom } from '../store/store'
import styles from 'styles/components/MobileControls.module.scss'

const {
  mobile_controls,
  // arrows_area,
  // triangle,
  // left_triangle,
  // right_triangle,
  // up_triangle,
  // down_triangle,
  running_button,
  running_button_bg,
  mobile_running_active,
} = styles

const activeDirOne = {
  mBackward: true,
  mLeftward: true,
  mRightward: false,
  mForward: false,
}

const activeDirTwo = {
  mBackward: true,
  mLeftward: false,
  mRightward: false,
  mForward: false,
}

const activeDirThree = {
  mBackward: true,
  mLeftward: false,
  mRightward: true,
  mForward: false,
}

const activeDirFour = {
  mBackward: false,
  mLeftward: true,
  mRightward: false,
  mForward: false,
}

const activeDirFive = {
  mBackward: false,
  mLeftward: false,
  mRightward: false,
  mForward: false,
}

const activeDirSix = {
  mBackward: false,
  mLeftward: false,
  mRightward: true,
  mForward: false,
}

const activeDirSeven = {
  mBackward: false,
  mLeftward: true,
  mRightward: false,
  mForward: true,
}

const activeDirEight = {
  mBackward: false,
  mLeftward: false,
  mRightward: false,
  mForward: true,
}

const activeDirNine = {
  mBackward: false,
  mLeftward: false,
  mRightward: true,
  mForward: true,
}

const JOYSTICK_COLOR = '#6b6b6b'

const MobileControls = () => {
  const joystick_manager_ref = useRef<JoystickManager | null>(null)
  const [, setActiveMobileDirectionsObj] = useAtom(activeMobileDirectionsAtom)
  const [activeMobileSprint, setActiveMobileSprint] = useAtom(activeMobileSprintAtom)

  const toggleMobileSprint = () => {
    setActiveMobileSprint(!activeMobileSprint)
  }

  useEffect(() => {
    if (!joystick_manager_ref.current) {
      // 1) Create the options object for our joystick
      const options: JoystickManagerOptions = {
        zone: document.getElementById('joystick_canvas')!,
        size: 100,
        color: JOYSTICK_COLOR,
        restOpacity: 0.7,
        dynamicPage: true,
      }

      // 2) Pass the options into the manager to create the joystick
      joystick_manager_ref.current = nipplejs.create(options)
    }

    const resetPosition = () => {
      setActiveMobileDirectionsObj(activeDirFive)
    }

    const manageJoysticks = (_e: nipplejs.EventData, nipple: nipplejs.JoystickOutputData) => {
      const joystick = nipple as unknown as Joystick

      const handleJoystickMove = (_event: nipplejs.EventData, data: nipplejs.JoystickOutputData) => {
        const X = joystick!.frontPosition.x
        const Y = joystick!.frontPosition.y

        // OUTPUT 1
        if (X >= -47 && X < -15 && Y >= 15 && Y <= 47) {
          setActiveMobileDirectionsObj(activeDirOne)
        }

        // OUTPUT 2
        if (X >= -15 && X < 28 && Y >= 47) {
          setActiveMobileDirectionsObj(activeDirTwo)
        }

        // OUTPUT 3
        if (X >= 28 && X <= 47 && Y >= 10 && Y <= 47) {
          setActiveMobileDirectionsObj(activeDirThree)
        }

        // OUTPUT 6
        if (X > 47 && Y >= -10 && Y <= 10) {
          setActiveMobileDirectionsObj(activeDirSix)
        }

        // OUTPUT 9
        if (X >= 18 && X <= 48 && Y < -10 && Y >= -48) {
          setActiveMobileDirectionsObj(activeDirNine)
        }

        // OUTPUT 8
        if (X >= -15 && X <= 15 && Y < -47) {
          setActiveMobileDirectionsObj(activeDirEight)
        }

        // OUTPUT 7
        if (X >= -38 && X < -15 && Y < -10 && Y >= -45) {
          setActiveMobileDirectionsObj(activeDirSeven)
        }

        // OUTPUT 4
        if (X <= -32 && Y >= -10 && Y <= 10) {
          setActiveMobileDirectionsObj(activeDirFour)
        }

        // CENTRAL RESET AREA - Data.distance returns how far the joystick is from the center using numbers from 1 to 50
        // 0 = total center (rest state), 50 = dragged to the furthermost edge. I consider 15 a good central point to work smoothly.
        if (data.distance <= 15) {
          setActiveMobileDirectionsObj(activeDirFive)
        }
      }

      joystick.on('end', resetPosition)
      joystick.on('move', handleJoystickMove)
    }

    joystick_manager_ref.current.on('added', manageJoysticks)

    return () => {
      joystick_manager_ref.current?.off('added', manageJoysticks)
    }
  }, [setActiveMobileDirectionsObj])

  return (
    <div className={`${mobile_controls}`}>
      <div id="joystick_canvas">
        {/* <div className={arrows_area}>
          <div className={`${triangle} ${left_triangle}`}></div>
          <div className={`${triangle} ${up_triangle}`}></div>
          <div className={`${triangle} ${right_triangle}`}></div>
          <div className={`${triangle} ${down_triangle}`}></div>
        </div> */}
      </div>

      <div
        className={`${running_button} ${activeMobileSprint ? mobile_running_active : ''}`}
        onClick={toggleMobileSprint}
      >
        <div className={running_button_bg}></div>
        <img src="/images/ui-icons/running.png" alt="running icon" />
      </div>
    </div>
  )
}

export default MobileControls
